<template>
  <div class="dashboard-page-wrapper test-page">
    <div class="top-wrap">
      <div class="text-img">
        <h2> Multi Stage Separator Test </h2>
        <div v-if="receivedData">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-if="receivedData && receivedData.sepTestProperties && receivedData.sepTestProperties.length > 0">
        <v-img src="../../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap" :style="{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px'
          }">
            <template v-for="(item, index) in receivedData.sepTestProperties" :key="item.originalKey">
              <div v-if="item.value" class="field-item">
                <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
                <p class="test-top-values" style="margin: 0;">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                        {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                      </span>
                      <span v-bind="props" v-else class="value-text">
                        {{ item.value }}
                      </span>
                    </template>
                    <span>{{ item.value }}</span>
                  </v-tooltip>
                  <span v-if="item.unit">&nbsp;{{ item.unit }}</span>
                </p>
              </div>
            </template>
          </div>
        </div>

        <div v-if="!receivedData.sepTestProperties || receivedData.sepTestProperties.length === 0">
          No data available.
        </div>
      </div>
      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div class="tabs-data" ref="scrollable" tabindex="0" @keydown="handleKeyDown">
      <div class="tabs-toggle">
        <v-tabs v-model="tab" @update:model-value="handleTabChange">
          <v-tab value="one">Multi Stage Separator Test</v-tab>
          <v-tab v-if="!isPvtTest" value="two">Liberated Gas Compositions</v-tab>
          <v-tab v-if="!isPvtTest" value="three">Residual Oil Compositions</v-tab>
        </v-tabs>

    <div class="switch-div">
        <div v-if="!isPvtTest && tab === 'three'">
          <v-btn-toggle v-model="toggleFractionParent" mandatory
            class="elevation-0 axis-toggle" @update:modelValue="handleToggleChange">
            <v-btn :value="true" class="switch-btn text-none text-caption">wt%</v-btn>
            <v-btn :value="false" class="switch-btn text-none text-caption">mol%</v-btn>
          </v-btn-toggle>
        </div>
      </div>
      </div>

      <v-card-text class="pa-0 pt-4">
        <v-window v-model="tab">
          <v-window-item value="one">
            <SeparatorTestData @data-updated="handleDataUpdate" :yAxisScale="yAxisScale" ref="separatorTestData" />
          </v-window-item>

          <v-window-item v-if="!isPvtTest" value="two">
            <LiberatedGasCompositon :yAxisScale="yAxisScale" ref="liberatedGasComposition" />
          </v-window-item>

          <v-window-item v-if="!isPvtTest" value="three">
            <ResidualOilComposition @data-updated="handleDataUpdate" @toggleFraction="toggleFractionFunction" ref="residualOilComposition" :yAxisScale="yAxisScale" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import SeparatorTestData from "../MultiStageSeparatorTest/SeparatorTestData.vue";
import TestLoaders from '../Loaders/TestLoaders.vue';
import LiberatedGasCompositon from './LiberatedGasCompositon.vue';
import ResidualOilComposition from './ResidualOilComposition.vue';
import axios from "axios";
import { executeSampleReportDownload } from "../../../utils/sampleReportDownload";
import { getTenantPrefixFromRoute } from "@/utils/tenant";
import { isPvtTestRoute } from "@/utils/pvtTestRoute";
export default {
  components: { SeparatorTestData, TestLoaders, LiberatedGasCompositon, ResidualOilComposition, },
  name: "DataTabs",
  computed: {
    isPvtTest() {
      return isPvtTestRoute(this.$route);
    },
  },
  data() {
    return {
      toggleFractionParent: true,
      tab: null,
      receivedData: null,
      pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
      pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
      pdfLoader: false,
      snackbarMessage: null,
      yAxisScale: "linear",
    };
  },
  methods: {
    handleTabChange() {
      if (this.$refs.separatorTestData) {
        this.$refs.separatorTestData.sendDataToParent();
      }
      if (this.$refs.residualOilComposition) {
        this.$refs.residualOilComposition.sendDataToParent();
      }
    },
    handleYScaleToggleChange() {
  this.yAxisScale = this.isYLog ? "log" : "linear";
  this.$emit("y-axis-scale", this.yAxisScale);
},
    updateToggleFractionComp(value) {
      this.toggleFractionParent = value; // Update the parent state when child emits an event
    },
    handleToggleChange() {
        this.$refs.residualOilComposition.toggleFraction = this.toggleFractionParent; // Sync state with the child
        this.$refs.residualOilComposition.toggleFractionFunction(); // Call the child's 
    },
    handleDataUpdate(data) {
      this.receivedData = data;
    },
    handleKeyDown(event) {
      const key = event.key;
      const tabs = this.isPvtTest ? ['one'] : ['one', 'two', 'three'];
      if (key === 'ArrowDown') {
        this.$refs.scrollable.scrollTop += 50;
      } else if (key === 'ArrowLeft') {
        const currentIndex = this.tab ? tabs.indexOf(this.tab) : 0;
        this.tab = currentIndex <= 0 ? tabs[tabs.length - 1] : tabs[currentIndex - 1];
      } else if (key === 'ArrowRight') {
        const currentIndex = this.tab ? tabs.indexOf(this.tab) : 0;
        this.tab = currentIndex === tabs.length - 1 ? tabs[0] : tabs[currentIndex + 1];
      }
    },
    async goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      try {
        const tenantId = getTenantPrefixFromRoute(this.$route) || "";
        const sampleId = this.$route.params.sampleId;
        const result = await executeSampleReportDownload({
          extension: "pdf",
          httpGet: () =>
            axios.get(
              process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                  "X-TenantID": tenantId,
                },
                responseType: "blob",
              }
            ),
        });
        if (!result.ok && !result.limitModal && result.snackbarMessage) {
          this.snackbarMessage = result.snackbarMessage;
        }
      } finally {
        this.pdfLoader = false;
      }
    },
  },
  created() {
    if (this.isPvtTest) {
      this.toggleFractionParent = false;
    }
  },
  mounted() {
    this.tab = 'one';
    this.$refs.scrollable.focus();
  },
};
</script>